import React, { useEffect, useMemo, useState } from "react";
import Input from "react-phone-number-input/input";

type InputPatientDetailPhoneProps = {
  value?: string;
  onChange?: (phone: string) => void;
};

const toE164IfValid = (raw?: string): string | null => {
  if (!raw) return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  if (!trimmed.startsWith("+")) return null;

  const digits = trimmed.replace(/[^\d]/g, "");
  if (digits.length < 8 || digits.length > 15) return null;
  return `+${digits}`;
};

const InputPatientDetailPhone: React.FC<InputPatientDetailPhoneProps> = ({
  value = "",
  onChange,
}) => {
  const e164Value = useMemo(() => toE164IfValid(value), [value]);
  const [phone, setPhone] = useState<string | undefined>(e164Value || value);

  useEffect(() => {
    setPhone(e164Value || value);
  }, [e164Value, value]);

  const handleChange = (newValue?: string) => {
    setPhone(newValue);
    if (onChange) {
      onChange(newValue || "");
    }
  };

  const inputStyle = {
    width: "100%",
    maxWidth: "226px",
    fontFamily: "Urbanist600",
    fontSize: 16,
    color: "#282B33",
    letterSpacing: 0.032,
    padding: "0px 16px",
    margin: 0,
    height: "30px",
    border: "1px solid #C4C6CD",
    borderRadius: "10px",
  } as const;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
    >
      <p
        style={{
          width: "130px",
          fontFamily: "Urbanist500",
          fontWeight: 500,
          fontSize: 16,
          color: "#282B33",
          letterSpacing: 0.032,
          padding: 0,
          margin: 0,
          flexShrink: 0, // Add this line
        }}
      >
        Phone:
      </p>
      {e164Value ? (
        <Input
          style={inputStyle}
          placeholder=""
          international
          withCountryCallingCode
          value={phone}
          onChange={handleChange}
        />
      ) : (
        <input
          style={inputStyle}
          placeholder=""
          value={phone ?? ""}
          onChange={(event) => handleChange(event.target.value)}
        />
      )}
    </div>
  );
};

export default InputPatientDetailPhone;
